<div class='item-choice-container' tabindex="-1"
  [ngClass]="{'text-muted': currentStep?.selectedOrderableItem && !currentStep?.isSelectedAlternativeItem(item)}">
  <div class='info'>
    <div>
      <h4 class='item-label font-secondary fw-500'
        [tabindex]="currentStep?.selectedOrderableItem && !currentStep?.isSelectedAlternativeItem(item) ? -1 : 0">
        <span [attr.aria-label]="'component.special_wizard_item_selector_entry.selected' | translate"
          *ngIf='currentStep?.selectedOrderableItem && currentStep?.isSelectedAlternativeItem(item)'>&#10003;</span>
        <span [attr.aria-label]="item.availableSizePrices[0].label"
          *ngIf="item.availableSizePrices && item.availableSizePrices.length === 1 && item.availableSizePrices[0].size !== 'Size'">
          {{item.availableSizePrices[0].label}}
        </span>
        <span [attr.aria-label]="item.label" class="margin-right-10">
          {{item.label}}<sup *ngIf="item.labelSymbol">{{item.labelSymbol}}</sup>
        </span>
        <div class="item-tags">
          <fts-tags *ngIf="item?.tags?.length" [tags]="item?.tags" class="tags-wrapper"></fts-tags>
        </div>
      </h4>
      <span 
        *ngIf="selectedSizePrice?.noticePeriod && hasCateringNoticeTime" 
        style="font-size: 18.66px; font-weight: 700;" 
        class="selection-text-color">
        {{'component.size_price_button.prep_time' | translate}}{{formattedNoticePeriod}}
      </span>
      <p *ngIf='calories'
        [tabindex]="currentStep?.selectedOrderableItem && !currentStep?.isSelectedAlternativeItem(item) ? -1 : 0"
        class='margin-top-5 margin-bottom-0 calories-display' [attr.aria-label]='calories'>{{calories}}</p>
    </div>
    <fts-item-choice [stepItem]="item" [currentStep]="currentStep" (itemSelected)="onItemSelected($event)"
      (sizeSelected)='onSizeSelected($event)' ftsDeactivated [pnlItem]="item"></fts-item-choice>
  </div>
  <div class="row item-description">
    <div class="col-xl-10 col-md-10 col-lg-10 small">
      <p [tabindex]="currentStep?.selectedOrderableItem && !currentStep?.isSelectedAlternativeItem(item) ? -1 : 0"
        *ngIf="item.description">{{item.description}}</p>
    </div>
    <div class="col-xl-2 col-md-2 col-lg-2 text-right">
      <span *ngIf="surcharge !== 0"
        [tabindex]="currentStep?.selectedOrderableItem && !currentStep?.isSelectedAlternativeItem(item) ? -1 : 0"
        class="opac-08">
        <b>
          <ng-container *ngIf="surcharge > 0">
            + {{surcharge | currency: 'USD': 'symbol'}}
          </ng-container>
          <ng-container *ngIf="surcharge < 0">
            &minus; {{-surcharge | currency: 'USD': 'symbol'}}
          </ng-container>
        </b>
      </span>
    </div>
  </div>
</div>